import { useLanguage } from "../../context/LanguageContext";
import { Seo } from "../../components/Seo";
import { Reveal } from "../../components/Reveal";

const Block = ({ heading, children }) => (
  <section className="mt-10">
    <h2 className="font-display text-2xl text-foreground sm:text-3xl">{heading}</h2>
    <div className="mt-3 space-y-3 text-[15px] leading-relaxed text-foreground/72">{children}</div>
  </section>
);

export const LegalShell = ({ title, subtitle, updated, children }) => {
  const { t } = useLanguage();
  return (
    <div className="pt-24">
      <div className="mx-auto max-w-3xl px-5 py-14 sm:px-8 sm:py-20">
        <Reveal>
          <p className="text-[10px] uppercase tracking-[0.5em] text-gold">{t("legal.eyebrow")}</p>
          <h1 className="mt-4 font-display text-4xl leading-tight text-foreground sm:text-5xl">{title}</h1>
          {subtitle && <p className="mt-4 text-lg text-foreground/70">{subtitle}</p>}
          {updated && (
            <p className="mt-4 text-xs uppercase tracking-widest text-foreground/45">
              {t("legal.lastUpdate")}: {updated}
            </p>
          )}
        </Reveal>
        <div className="mt-8">{children}</div>
      </div>
    </div>
  );
};

export { Block };
